export default __webpack_public_path__ + "media/images/new_year/header_1920x1080_2-6e052cd6e4fc3a4eb10004045dd74515.webp";